// extracted by mini-css-extract-plugin
export default {"notFound":"not-found_notFound__KNCai"};